<template>
  <div class="modal" @keyup.esc="closeModal">
    <div class="modal__open-btn" @click.prevent="openModal" ref="openModal">
      <slot name="button" :ally="showModal" />
    </div>
    <div class="modal__backface" v-show="showModal" @click="closeModal" />
    <dialog
      role="dialog"
      aria-modal="true"
      :open="showModal"
      :aria-labelledby="ariaLabelledby"
      class="modal__wrapper"
      :class="animateModal ? '--opened' : ''"
      ref="wrapper"
    >
      <button
        type="button"
        class="modal__close-btn btn-close"
        @click="closeModal"
        ref="closeButton"
        v-if="modelType === 'accessbility'"
        :v-tag:useractionevent="{
          category: 'content',
          action: 'select::accessibility layer',
          label: 'close',
        }"
      >
        <span>{{ closeAriaLabel }}</span>
        <span class="btn--close" />
      </button>
      <button
        v-else
        type="button"
        class="modal__close-btn btn-close"
        @click="closeModal"
        id="countryCloseBtn"
        :v-tag:useractionevent="{
          category: 'content',
          action: 'select::accessibility layer',
          label: 'close',
        }"
      >
        <span>{{ closeAriaLabel }}</span>
        <span class="btn--close" />
      </button>
      <div class="modal__content">
        <slot :showModal="showModal" />
      </div>
    </dialog>
  </div>
</template>
<script>
  import { tag } from '@Foundation/analyticsHandler/directives/tag.js';
  import { removePageScroll } from '@Foundation/mixins/removePageScroll';
  import { AnalyticsHandler } from '@Foundation/analyticsHandler';
  export default {
    name: 'modal',
    directives: {
      tag,
    },
    mixins: [removePageScroll],
    props: {
      closeAriaLabel: {
        type: String,
        required: false,
        default: undefined,
      },
      ariaLabelledby: {
        type: String,
        required: false,
        default: undefined,
      },
      ariaDescribedby: {
        type: String,
        required: false,
        default: undefined,
      },
      analytics: {
        type: String,
        required: false,
        default: undefined,
      },
    },
    data() {
      return {
        showModal: false,
        animateModal: false,
        focusableElms: null,
        modelType: 'accessbility',
      };
    },
    mounted() {
      this.$el.style.display = '';
    },
    methods: {
      isUsingKeyboard() {
        return document.body.classList.contains('is-using-keyboard');
      },
      closeEvent() {
        this.$root.$emit('modal::close');
        AnalyticsHandler.pushDataLayer({
          event: 'uaevent',
          eventCategory: 'content',
          eventAction: this.analytics,
          eventLabel: 'close',
        });
      },
      openModal() {
        this.showModal = true;
        this.removePageScroll(true);
        const countryModal =
          this.$refs.openModal.getElementsByClassName('icon-world').length;
        if (countryModal === 0) {
          this.modelType = 'accessbility';
          window._uxa = window._uxa || [];
          window._uxa.push([
            'trackPageview',
            window.location.pathname +
              window.location.hash.replace('#', '?__') +
              '?cs-popin-accessbility',
          ]);
        } else {
          this.modelType = 'country';
          window._uxa = window._uxa || [];
          window._uxa.push([
            'trackPageview',
            window.location.pathname +
              window.location.hash.replace('#', '?__') +
              '?cs-popin-country-selector',
          ]);
        }
        setTimeout(() => {
          this.animateModal = true;
          this.setFocus();
        }, 500);
      },
      closeModal() {
        this.showModal = false;
        this.animateModal = false;
        this.removePageScroll(false);
        window._uxa = window._uxa || [];
        window._uxa.push([
          'trackPageview',
          window.location.pathname + window.location.hash.replace('#', '?__'),
        ]);
        this.closeEvent();
      },
      setFocus() {
        const modal = document.querySelector('.modal__wrapper'); // select the modal by it's id
        if (this.modelType === 'accessbility') {
          const focusableElements = ['button, input'];
          const firstFocusableElement =
            modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
          document.querySelector('.modal__wrapper .btn-close').focus();
          document.addEventListener('keydown', function (e) {
            const lastFocusableElements = document.getElementsByName(
              'contrast'
            )[0].checked
              ? document.getElementsByName('contrast')[0]
              : document.getElementsByName('contrast')[1];
            const isTabPressed = e.key === 'Tab' || e.keyCode === 9;
            if (!isTabPressed) {
              return;
            }
            if (e.shiftKey) {
              // if shift key pressed for shift + tab combination
              if (document.activeElement === firstFocusableElement) {
                lastFocusableElements.focus();
                e.preventDefault();
              }
            } else {
              // if tab key is pressed
              if (document.activeElement === lastFocusableElements) {
                // if focused has reached to last focusable element then focus first focusable element after pressing tab
                firstFocusableElement.focus();
                e.preventDefault();
              }
            }
          });
        } else {
          const firstFocusableElement = document.getElementById('countryCloseBtn'); // get first element to be focused inside modal
          const lastFocusableElement = document.getElementsByClassName('selectCountry').length - 1;
          const lastFocus = document.getElementsByClassName('country-name');
          let lastElement = lastFocus[lastFocus.length - 1];
          document.getElementById('countryCloseBtn').focus();
          document.addEventListener('click', () => {
            if (document.activeElement.classList.contains('selectCountry')) {
              if (document.activeElement === lastElement) {
                lastElement = lastFocus[lastFocus.length - 1];
              } else {
                lastElement = document.getElementsByClassName('selectCountry')[lastFocusableElement];
              }
              if (document.activeElement === document.getElementsByClassName('selectCountry')[lastFocusableElement]) {
                lastElement = lastFocus[lastFocus.length - 1];
              }
            }
          });
          document.addEventListener('keydown', (e) => {
            const isTabPressed = e.key === 'Tab' || e.keyCode === 9;
            if (!isTabPressed) {
              return;
            }
            if (e.shiftKey) {
              // if shift key pressed for shift + tab combination
              if (document.activeElement === firstFocusableElement) {
                lastElement.focus(); // add focus for the last focusable element
                e.preventDefault();
                e.stopPropagation();
              }
            } else {
              if (document.activeElement === lastElement) {
                firstFocusableElement.focus();
                e.preventDefault();
                e.stopPropagation();
              }
            }
          });
        }
      },
      focusLoop() {
        this.focusableElms = [
          ...this.$el.querySelectorAll('a, button, input'),
        ].slice(1);
        this.focusableElms.forEach((element) => {
          element.setAttribute('focusable', 'isFocusable');
          element.addEventListener('blur', () => {
            setTimeout(() => {
              const activeElementClass =
                document.activeElement.getAttribute('focusable');
              /* istanbul ignore else */
              if (
                !window.matchMedia('(min-width: 1024px)').matches &&
                activeElementClass !== 'isFocusable' &&
                this.isUsingKeyboard()
              ) {
                this.focusableElms[1].focus();
              } else if (activeElementClass !== 'isFocusable') {
                this.focusableElms[0].focus();
              }
            }, 30);
          });
        });
      },
    },
  };
</script>
